/**
 * 旅行社信用額度（D2）— 純計算，供伺服器擋單與前端側欄/警示共用。
 *
 * 一律 HKD（D10）。已使用額度＝排除「已取消」與「已收款（paymentStatus=paid）」的
 * 訂單 priceHkd 加總（已完成仍佔用；Phase 7 起結算單標記已付即連動收款、額度自動釋放）。
 * limit=null 代表未設限、不擋單。
 * 規則：used + 本單 > limit 才擋（剛好填滿至 limit 允許，之後才擋）。
 */
export type CreditStatus = {
  limit: number | null; // 戶口額度（HKD）；null=未設限
  used: number; // 已使用額度（HKD）
  available: number | null; // 可用額度＝limit−used；null=未設限
  wouldExceed: boolean; // 加上 incoming 後是否超過額度（未設限恆 false）
};

const round2 = (x: number) => Math.round(x * 100) / 100;

export function creditStatus(
  limit: number | null,
  used: number,
  incomingHkd = 0,
): CreditStatus {
  const u = round2(used);
  if (limit === null) {
    return { limit: null, used: u, available: null, wouldExceed: false };
  }
  return {
    limit,
    used: u,
    available: round2(limit - u),
    wouldExceed: round2(u + incomingHkd) > limit,
  };
}
